/**
 * `validateSearch` of `/admin/organizations`: `edit` is the organization whose panel opens as soon as
 * the page does, which is where the "Editar datos" of a customer's file in Clientes leads. Without
 * it the page is the grid it always was, and the panel opens with a click on a row.
 */
export interface OrganizationsSearch {
  edit?: string;
}

export function organizationsSearchSchema(search: Record<string, unknown>): OrganizationsSearch {
  const edit = search['edit'];
  return typeof edit === 'string' && edit.length > 0 ? { edit } : {};
}
